import Recurrence from "./SVG/recurrence.svg?react";

const RecurrenceIcon = () => {
  return <Recurrence />;
};

export default RecurrenceIcon;
